export default function ComingSoon() {
  return (
    <div className="min-h-screen w-full animated-gradient flex items-center justify-center px-6">
      <div className="text-center">
        <img
          src="/logo.jpeg"
          alt="Company Logo"
          className="mx-auto h-48 w-48 md:h-56 md:w-56 object-contain animate-float"
        />
        <h1 className="text-4xl md:text-6xl font-bold shimmer-text fade-in-up leading-normal md:leading-[1.25] mb-3 md:mb-4 overflow-visible font-poppins">Coming Soon</h1>
        <p className="text-base md:text-lg text-gray-600 fade-in-up delay-1 mt-3 md:mt-4 font-poppins">Sell your car in Ahmedabad.</p>
        <a
          href="https://forms.gle/Xn2hmkxZYqmSDMMx5"
          target="_blank"
          rel="noopener noreferrer"
          className="fade-in-up delay-2 inline-flex items-center justify-center mt-4 md:mt-6 px-6 py-3 rounded-md text-white font-semibold shadow-sm transition-transform duration-200 hover:scale-[1.03] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
          style={{ backgroundColor: 'var(--color-primary)' }}
        >
          Register Now
        </a>
      </div>
    </div>
  )
}


